// TODO: Should I keep this in the root context file or this is fine?

import { createContext, useContext } from 'react';
import { DashboardPageOptions } from './types';

export const DashboardPageOptionsContext =
  createContext<DashboardPageOptions | null>(null);

export const useDashboardPageOptionsContext = () => {
  const context = useContext(DashboardPageOptionsContext);
  if (!context) {
    throw new Error(
      'useDashboardPageOptionsContext must be used within a DashboardPageOptionsContextProvider'
    );
  }
  return context;
};
